/* Component Dependencies */
var guestReviewsCtaTemplate = require('templates/guestReviewsCta.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'guestReviewsCta',
  template: {
    'guestReviewsCta': guestReviewsCtaTemplate
  }
});
